import React from 'react';

const BackButton = () => {
  const handleBack = () => {
    window.location.hash = '#/';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={handleBack}
      className="flex items-center gap-2 text-primary-600 hover:text-primary-700 font-semibold mb-6 transition-colors group"
    >
      <svg 
        className="w-5 h-5 transform group-hover:-translate-x-1 transition-transform" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      <span>Back to Home</span>
    </button>
  );
};

export default BackButton;







